import React from "react";

export function UpcomingBookings(){
    return(
        <>
            <div>Upcoming Bookings </div>
        </>
    )
}